<!--
 * @Module  精选案例内页
 -->

<template>
  <div class="main-wrapper">
    <div class="content-wrapper">
      <div class="news-wrapper">
        <div class="crumb-row">
          <el-breadcrumb class="crumbs" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/sampleReels' }"
              >精选案例</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/' }">{{
              caseDetail.name
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="news-content">
          <div class="news-title">
            <span class="name">{{ caseDetail.name }}</span>
            <span class="icon">
              <span
                ><i class="iconfont icon-browse"></i
                >{{ caseDetail.browseLogCount }}</span
              >
            </span>
          </div>
          <div class="news-detail">
            <mavon-editor
              :subfield="prop.subfield"
              :defaultOpen="prop.defaultOpen"
              :toolbarsFlag="prop.toolbarsFlag"
              :editable="prop.editable"
              :scrollStyle="prop.scrollStyle"
              :imageClick="handleImageClick"
              v-model="caseDetailContent"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!--JavaScript-->
<script>
import DetailVideo from './video.vue';
export default {
  components: {
    DetailVideo,
  },
  data() {
    return {
      caseDetail: {},
      caseDetailContent: null,
    };
  },
  created() {
    this.$nextTick(() => {
      this.dataInit();
    });
  },
  methods: {
    async dataInit() {
      let params = {
        id: this.$route.params.sampleId,
      };
      this.caseDetail = await this.$store.dispatch('sample/getCase', params); // 案例详情数据
      this.caseDetailContent =
        this.caseDetail && this.caseDetail.content
          ? this.caseDetail.content.replaceAll('103.38.233.24', '140.207.51.19')
          : '';
    },
    handleImageClick() {
      return false;
    },
  },
  computed: {
    prop() {
      let data = {
        subfield: false, // 单双栏模式
        defaultOpen: 'preview', //edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        editable: false,
        toolbarsFlag: false,
        scrollStyle: true,
        imageClick: null,
      };
      return data;
    },
  },
  watch: {},
  filters: {},
};
</script>
<!--CSS-PAGE-->
<style lang="scss" scoped>
.main-wrapper {
  float: left;
  min-height: calc(100vh - 120px);
  background: rgb(247, 247, 247);
  width: 100%;
  .content-wrapper {
    display: block;
    width: 1200px;
    min-height: 794px;
    padding-bottom: 30px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #fff;
    .news-wrapper {
      width: 950px;
      display: block;
      margin: 0 auto;
      .crumb-row {
        width: 100%;
        .el-breadcrumb {
          font-size: 13px;
          height: 50px;
          line-height: 50px;
        }
      }
      .news-content {
        .news-title {
          height: 30px;
          line-height: 30px;
          padding-bottom: 20px;
          margin-bottom: 20px;
          border-bottom: 1px solid #e0e0e0;
          .name {
            float: left;
            font-size: 22px;
            color: #333333;
          }
          .icon {
            float: right;
            font-size: 13px;
            color: #999999;
            i {
              display: inline-block;
              font-style: normal;
              height: 30px;
              line-height: 30px;
              margin-right: 5px;
            }
          }
        }
        .news-detail {
          font-size: 14px;
          color: #666666;
          line-height: 26px;
          .label {
            font-size: 20px;
            color: #333333;
            margin-bottom: 15px;
          }
          .label:before {
            content: 'Core Value |';
            margin-right: 5px;
            font-size: 20px;
            color: #f45331;
          }
          .label.now {
            margin-top: 50px;
          }
          .label.now:before {
            content: 'Current |';
          }
        }
      }
    }
  }
}
</style>
